import type { ReactNode } from 'react'

import { Flex } from '@enechain/ecloud-designsystem'

/**
 * DS `Alert` の `children` に入れる導線 (ボタン) の器。 UI 辞書 components/alert-placement.md
 * 「4. Alert の中の導線（ボタン）」。
 *
 * - 見出しは Alert の `title`、 本文は `description` に渡し、 導線だけをこの器に入れて
 *   `children` にする。 本文の中・本文の下に導線の行を作らない
 * - DS 0.14.2 の `Alert` は本文の Stack に `flex: 1` を持たないので、 導線をそのまま
 *   `children` に入れると本文の直後に付く。 `marginLeft: auto` で右端へ寄せ、 本文に押されて
 *   縮まないようにする ([DS差異] DS に右寄せの action slot が無い)
 * - 部品は `TertiaryButton size="sm"` が既定。 その Alert から業務を進める主操作が 1 つだけの時は
 *   `PrimaryButton size="sm"` (Tertiary の右)。 2 個まで。 文字リンク・Secondary・md・
 *   アイコンだけのボタンは使わない
 * - 幅が足りない時に本文の下へ回す作り (8080 の container query) は React 側では未決
 *   (辞書「React 側の作りは、 DS 側への要望とあわせて決める」)。 ここでは持たない
 */
export const AlertActions = ({
  children,
}: {
  children: ReactNode
}): React.ReactElement => (
  <Flex alignItems="center" flexShrink={0} gap={2} marginLeft="auto">
    {children}
  </Flex>
)
